function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var c = 0;

function o() {
  return c += 1, "ambiki-".concat(Math.random().toString().slice(2, 6), "-").concat(c);
}

function h(i, t, e) {
  var s = i.indexOf(t);
  s === i.length - 1 && e === 1 && (s = -1);
  var u = e === 1 ? 0 : i.length - 1;

  if (t && s >= 0) {
    var n = s + e;
    n >= 0 && n < i.length && (u = n);
  }

  return i[u];
}

function r(i) {
  return !i.hasAttribute("disabled") && i.getAttribute("aria-disabled") !== "true";
}

var p = !!navigator.userAgent.match(/Macintosh/),
    l = /*#__PURE__*/function () {
  function l(t, e) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$multiple = _ref.multiple,
        s = _ref$multiple === void 0 ? !1 : _ref$multiple;

    _classCallCheck(this, l);

    this.input = void 0;
    this.list = void 0;
    this.multiple = void 0;
    this.isMouseMoving = !1;
    this.input = t, this.list = e, this.multiple = s, this.list.id || (this.list.id = o()), this.input.getAttribute("aria-expanded") || this.input.setAttribute("aria-expanded", "false"), this.multiple && this.input.setAttribute("aria-multiselectable", "true"), this.input.setAttribute("role", "combobox"), this.input.setAttribute("aria-haspopup", "listbox"), this.input.setAttribute("aria-autocomplete", "list"), this.list.setAttribute("role", "listbox"), this.onKeydown = this.onKeydown.bind(this), this.onClick = this.onClick.bind(this), this.onListMouseover = this.onListMouseover.bind(this), this.onListMousemove = this.onListMousemove.bind(this);
  }

  _createClass(l, [{
    key: "start",
    value: function start() {
      this.isMouseMoving = !1, this.input.setAttribute("aria-expanded", "true"), this.input.setAttribute("aria-controls", this.list.id), this.input.addEventListener("keydown", this.onKeydown), this.list.addEventListener("click", this.onClick), this.list.addEventListener("mouseover", this.onListMouseover), this.list.addEventListener("mousemove", this.onListMousemove), this.initializeOptions();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isMouseMoving = !1, this.input.setAttribute("aria-expanded", "false"), this.input.removeAttribute("aria-controls"), this.input.removeEventListener("keydown", this.onKeydown), this.list.removeEventListener("click", this.onClick), this.list.removeEventListener("mouseover", this.onListMouseover), this.list.removeEventListener("mousemove", this.onListMousemove), this.deselectAll(), this.deactivate();
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(t) {
      if (this.isMouseMoving = !1, !(t.shiftKey || t.metaKey || t.altKey) && !(!p && t.ctrlKey)) switch (t.key) {
        case "Enter":
        case "Tab":
          if (!this.activeOption || !r(this.activeOption)) break;
          t.preventDefault(), t.stopPropagation(), this.activeOption.click();
          break;

        case "Escape":
          this.deactivate();
          break;

        case "ArrowDown":
          t.preventDefault(), t.stopPropagation(), this.activeOption ? this.move(1) : this.activate(this.visibleOptions[0], {
            scroll: !0
          });
          break;

        case "ArrowUp":
          t.preventDefault(), t.stopPropagation(), this.activeOption ? this.move(-1) : this.activate(this.visibleOptions[this.visibleOptions.length - 1], {
            scroll: !0
          });
          break;

        case "Home":
          t.preventDefault(), t.stopPropagation(), this.activate(this.visibleOptions[0], {
            scroll: !0
          });
          break;

        case "End":
          t.preventDefault(), t.stopPropagation(), this.activate(this.visibleOptions[this.visibleOptions.length - 1], {
            scroll: !0
          });
          break;

        default:
          if (t.ctrlKey) break;
          this.deactivate();
      }
    }
  }, {
    key: "onClick",
    value: function onClick(t) {
      var e = a(t.target);
      !e || !r(e) || (this.multiple ? this.isSelected(e) ? this.deselect(e) : this.select(e) : this.select(e), e.dispatchEvent(new CustomEvent("combobox:commit", {
        bubbles: !0
      })));
    }
  }, {
    key: "onListMouseover",
    value: function onListMouseover(t) {
      if (!this.isMouseMoving) {
        t.preventDefault();
        return;
      }

      var e = a(t.target);
      !e || this.activate(e);
    }
  }, {
    key: "onListMousemove",
    value: function onListMousemove(t) {
      if (this.isMouseMoving) return;
      this.isMouseMoving = !0;
      var e = a(t.target);
      !e || this.activate(e);
    }
  }, {
    key: "select",
    value: function select(t) {
      if (this.multiple) {
        t.setAttribute("aria-selected", "true");
        return;
      }

      var _iterator = _createForOfIteratorHelper(this.options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var e = _step.value;
          e.setAttribute("aria-selected", (e === t).toString());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "deselect",
    value: function deselect(t) {
      t.setAttribute("aria-selected", "false");
    }
  }, {
    key: "deselectAll",
    value: function deselectAll() {
      var _iterator2 = _createForOfIteratorHelper(this.options),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var t = _step2.value;
          this.deselect(t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "activate",
    value: function activate(t) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$scroll = _ref2.scroll,
          e = _ref2$scroll === void 0 ? !1 : _ref2$scroll;

      var _iterator3 = _createForOfIteratorHelper(this.options),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var s = _step3.value;
          s.id === t.id ? (s.setAttribute("data-active", ""), this.input.setAttribute("aria-activedescendant", s.id), e && s.scrollIntoView({
            block: "nearest"
          })) : s.removeAttribute("data-active");
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.input.removeAttribute("aria-activedescendant");

      for (var _i = 0, _Array$from = Array.from(this.list.querySelectorAll('[role="option"][data-active]')); _i < _Array$from.length; _i++) {
        var t = _Array$from[_i];
        t.removeAttribute("data-active");
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected(t) {
      return t.getAttribute("aria-selected") === "true";
    }
  }, {
    key: "options",
    get: function get() {
      return Array.from(this.list.querySelectorAll('[role="option"]'));
    }
  }, {
    key: "visibleOptions",
    get: function get() {
      return this.options.filter(d);
    }
  }, {
    key: "activeOption",
    get: function get() {
      return this.list.querySelector("[data-active]");
    }
  }, {
    key: "move",
    value: function move(t) {
      if (!this.activeOption) return;
      var e = h(this.visibleOptions, this.activeOption, t);
      this.activate(e, {
        scroll: !0
      });
    }
  }, {
    key: "initializeOptions",
    value: function initializeOptions() {
      var _iterator4 = _createForOfIteratorHelper(this.options),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var t = _step4.value;
          t.setAttribute("tabindex", "-1"), t.id || (t.id = o()), t.hasAttribute("aria-selected") || this.deselect(t);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }]);

  return l;
}();

function a(i) {
  if (!i) return !1;
  var t = i.closest('[role="option"]');
  return t || !1;
}

function d(i) {
  return !i.hidden && !(i instanceof HTMLInputElement && i.type === "hidden") && (i.offsetWidth > 0 || i.offsetHeight > 0);
}

export { l as default };